import React from 'react';
import { Box, ButtonBase, Dialog, Stack, Typography } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { appleTokens as t, tint } from '../../theme/appleTokens';
import PinPad from './ui/PinPad';

/**
 * Passage en mode Gestion (interrupteur Bar | Gestion de la barre du haut) : carte centrée sur fond flouté, même
 * pavé numérique que l'écran verrouillé. `onSubmit(code)` → promesse booléenne (code vérifié par l'API).
 */
export default function ManagementModeDialog({ open, onClose, onSubmit }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="management-mode-title"
      slotProps={{
        backdrop: { sx: { bgcolor: 'rgba(14, 16, 22, 0.45)', backdropFilter: 'blur(8px)' } },
        paper: {
          sx: {
            width: 340,
            maxWidth: 'calc(100vw - 32px)',
            borderRadius: '24px',
            px: 3,
            pt: 3.5,
            pb: 2,
            bgcolor: t.surface,
            boxShadow: '0 24px 60px rgba(16, 24, 40, 0.25)',
          },
        },
      }}
    >
      <Stack alignItems="center" spacing={0.75}>
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: tint(t.accent, 0.25),
            color: t.accentInk,
            mb: 0.5,
          }}
        >
          <ShieldOutlinedIcon sx={{ fontSize: 26 }} />
        </Box>
        <Typography id="management-mode-title" sx={{ ...t.type.title, color: t.label }}>
          Mode gestion
        </Typography>
        <Typography sx={{ ...t.type.small, color: t.secondaryLabel, textAlign: 'center' }}>Entrez le code pour accéder à toutes les pages.</Typography>
      </Stack>
      <Box sx={{ mt: 2.5 }}>{open ? <PinPad onSubmit={onSubmit} /> : null}</Box>
      <ButtonBase
        onClick={onClose}
        sx={{ alignSelf: 'center', mt: 1.5, px: 2, py: 0.75, borderRadius: t.radius.pill, ...t.type.smallStrong, color: t.secondaryLabel, '&:hover': { color: t.label, bgcolor: t.surfaceHover } }}
      >
        Annuler
      </ButtonBase>
    </Dialog>
  );
}
